import React from "react";

export default function Advertisement() {
  return (
    <div className="ads-restaurant-frame">
      <video className={"ads-video"} autoPlay={true} loop muted playsInline>
        <source type="video/mp4" src="/video/advertisement.mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
}
